import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Eye, EyeOff, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      nav("/admin/dashboard");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid-bg noise flex items-center justify-center px-6">
      <div className="w-full max-w-md rise">
        <Link to="/" className="flex items-center gap-2.5 mb-10" data-testid="login-home-link">
          <div className="h-8 w-8 rounded-md bg-primary grid place-items-center font-display font-bold">R</div>
          <span className="font-display font-semibold text-lg tracking-tight">Sales Leads Redoc</span>
        </Link>
        <form onSubmit={submit} className="bg-card border border-border rounded-2xl p-8 space-y-6" data-testid="admin-login-form">
          <div>
            <h1 className="text-2xl font-bold tracking-tight flex items-center gap-2"><Lock className="h-5 w-5 text-primary" />Admin access</h1>
            <p className="text-sm text-muted-foreground mt-1">Sign in with your administrator account.</p>
          </div>
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="h-11" data-testid="admin-login-email-input" autoComplete="username" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Password</Label>
            <div className="relative">
              <Input id="password" type={show ? "text" : "password"} required value={password}
                onChange={(e) => setPassword(e.target.value)} className="h-11 pr-11"
                data-testid="admin-login-password-input" autoComplete="current-password" />
              <button type="button" onClick={() => setShow(!show)} className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
                data-testid="admin-login-toggle-password" aria-label="Toggle password">
                {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
              </button>
            </div>
          </div>
          {error && (
            <div className="text-sm rounded-lg border border-rose-500/30 bg-rose-500/10 text-rose-700 px-3 py-2" data-testid="admin-login-error">{error}</div>
          )}
          <Button type="submit" disabled={busy} className="w-full h-11" data-testid="admin-login-submit-button">
            {busy ? "Signing in…" : "Sign in"}
          </Button>
        </form>
      </div>
    </div>
  );
}
